import { useEffect } from "react";
import useProveedores from "../hooks/useProveedores";
import { urlApi } from "../helpers/functionHelpers";

const SelectAlmacen = ({
  loading,
  error,
  ubicacions,
  almacenSeleccionado,
  onAlmacenChange,
  proveedorId,
}) => {
  const { proveedores: extraAlmacen } = useProveedores(
    `${urlApi}/api/proveedor-campos/almacen?proveedor_id=${proveedorId}`
  );

  useEffect(() => {
    if (
      extraAlmacen?.almacen &&
      extraAlmacen.almacen !== almacenSeleccionado
    ) {
      onAlmacenChange(extraAlmacen.almacen);
    }
  }, [extraAlmacen, almacenSeleccionado, onAlmacenChange]);

  if (loading) return <p>Cargando almacenes...</p>;
  if (error) return <p>Error al cargar almacenes</p>;

  const handleChange = (e) => {
    onAlmacenChange(e.target.value); // <-- solo enviamos el id
  };

  return (
    <select value={almacenSeleccionado} onChange={handleChange}>
      <option value="">Selecciona un almacén</option>
      {ubicacions.map((u) => (
        <option key={u.id} value={u.id}>
          {u.descripcion} {u.nombreEmpresa ? `(${u.nombreEmpresa})` : ''}
        </option>
      ))}
    </select>
  );
};

export default SelectAlmacen;